<template>
    <div>
        <div
            v-if="displaySize == 'large'"
            :role="role"
            class="rounded-md p-4"
            :class="classes.background"
        >
            <div class="flex">
                <div class="shrink-0">
                    <svg
                        class="h-6 w-6"
                        :class="classes.text"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke-width="2"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            :d="config[type].svg"
                        />
                    </svg>
                </div>
                <div class="ml-3">
                    <div class="text-base font-medium" :class="classes.text">
                        <slot />
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="displaySize == 'small'"
            :role="role"
            class="rounded-lg p-1"
            :class="classes.background"
        >
            <div class="m-1 text-base" :class="classes.text">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
// Full class strings, spelled out so Tailwind can see them (it can't detect
// classes assembled at runtime). The `branded-split-dark:` variant only fires
// on the pre-login branded screens in dark mode (see src/index.css); the rest
// of the app has no dark styling yet, so everywhere else these stay light.
const classesByType = {
    error: {
        background: 'bg-red-50 branded-split-dark:bg-red-950',
        text: 'text-red-600 branded-split-dark:text-red-300',
    },
    success: {
        background: 'bg-green-50 branded-split-dark:bg-green-950',
        text: 'text-green-600 branded-split-dark:text-green-300',
    },
    warning: {
        background: 'bg-yellow-50 branded-split-dark:bg-yellow-950',
        text: 'text-yellow-600 branded-split-dark:text-yellow-300',
    },
}

export default {
    computed: {
        role() {
            return this.type === 'error' ? 'alert' : 'status'
        },
        classes() {
            return classesByType[this.type]
        },
        config() {
            return {
                error: {
                    svg: 'M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
                },
                success: {
                    svg: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
                },
                warning: {
                    svg: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z',
                },
            }
        },
    },
    props: {
        type: {
            type: String,
            required: true,
            validator: (value) =>
                ['error', 'success', 'warning'].includes(value),
        },
        displaySize: {
            type: String,
            default: 'large',
        },
    },
}
</script>
